import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getSonarObjectsSearch } from '@api';

export const getCoreDataDictionarySearchSlice = createGetAsyncSlice({
	name: 'CoreDataDictionarySearch',
	receive: true,
	request: true,
	requestHandler: getSonarObjectsSearch,
	retainDataOnRequest: true
});
